import { notaFiscalProduto } from "../interfaces/notaFiscal/notaFiscalProduto";
import { createScannerItemType } from "../interfaces/scanner/createScannerItem";
import { isEanBarcodeLength, isPresentOnNotaFiscal } from "./notaFiscalUtils";

export function createScannerItem({
  barcode,
  total,
  notaFiscalProductsArray,
}: createScannerItemType): notaFiscalProduto {
  const totalNumber = parseFloat(total.replace(",", "."));
  const emptyDataPlaceHolder = "----"
  const isEanCode = isEanBarcodeLength(barcode)
  const existingProduct = isPresentOnNotaFiscal(
    barcode,
    notaFiscalProductsArray
  );

  const item: notaFiscalProduto = {
    cProd: existingProduct ? existingProduct.cProd : isEanCode ? emptyDataPlaceHolder : barcode,
    cEAN: existingProduct ? existingProduct.cEAN : isEanCode ? barcode : emptyDataPlaceHolder,
    xProd: existingProduct ? existingProduct.xProd : "Produto inesperado",
    uCom: existingProduct ? existingProduct.uCom : emptyDataPlaceHolder,
    qCom: totalNumber,
  };

  return item;
}
